<header [style.background-image]="'url(' + imageUrl + ')'">
  <h1>{{ title }}</h1>
</header>
